// https://wiki.imgo.tv/pages/viewpage.action?pageId=14217881
export const SHOW_TYPE = {
  M01: 'm01', // 沉浸式大图（背景预览+竖版海报3.6个）
  M02: 'm02', // 预约竖图（时间轴+竖版海报3.6个）
  M03: 'm03', // 预约横图（时间轴+横版海报3.6个）
  M04: 'm04' // 活动预约（图标+预约人数）
};

export const SLICK_CONFIG = {
  m01: {
    wrapStyle: {
      width: '7.5rem',
      marginTop: '-.85rem'
    },
    imgStyle: {
      width: '100%',
      height: '2.66rem'
    },
    slick_option: {
      slidesToShow: 3.6,
      slidesToScroll: 3
    }
  }
};

export const DEFAULT_SLICK_OPTION = {
  slidesToShow: 1,
  centerMode: false,
  infinite: false,
  mobileFirst: true,
  adaptiveHeight: false,
  centerPadding: 0,
  autoplay: false,
  autoplaySpeed: 5000,
  dots: false,
  arrows: false,
  speed: 200
};
